import { type Storefront } from 'niara-spear-crudmodel'
import type { HotelDetails } from '../types/hotels'
type Widgets = Storefront['widgets_homepage']

const R2_CDN_URL = process.env.R2_HOTEL_DETAILS_CDN_URL
const R2_CDN_BASE_URL = R2_CDN_URL?.endsWith('/') ? R2_CDN_URL : R2_CDN_URL + '/'

// Precisa garantir que todos esses hoteis já estejam na R2
const R2_HOTEL_IDS = [
  'HOTEL_OMNI_10027', // Demo - Bee2bee
  'HOTEL_OMNI_10081', // Niara
  'HOTEL_OMNI_2879', // Hotel Fazenda Vale da Mantiqueira
  'HOTEL_OMNI_10771', // Hotel Fazenda China Park
]

// Precisa garantir que todos os hoteis desses locators já estejam na R2
const R2_LOCATORS = [
  'valedamantiqueira', // Hotel Fazenda Vale da Mantiqueira
  'hotelfazendachina', // Hotel Fazenda China Park
]

// SE O HOTEL É DA R2, ENTÃO RETORNA A URL DA R2, CASO CONTRÁRIO, RETORNA A URL DO CDN PADRÃO DA OMNIBEES
export const convertHotelDetailsToR2 = (hotelDetails: HotelDetails): HotelDetails => {
  if (!hotelDetails) return hotelDetails

  const hotelId = hotelDetails?.hotelId

  if (!R2_HOTEL_IDS.includes(hotelId)) {
    return hotelDetails
  }
  return {
    ...hotelDetails,
    images: hotelDetails?.images.map((image) => {
      const fileName = image?.split('/')?.[image?.split('/')?.length - 1]
      return R2_CDN_BASE_URL + `${hotelId}/images/${fileName}`
    }),
    guestRooms: hotelDetails.guestRooms.map((room) => {
      return {
        ...room,
        medias: room.medias.map((media) => {
          return {
            ...media,
            images: media.images.map((image) => {
              const fileName = image?.url?.split('/')?.[image?.url?.split('/')?.length - 1]
              return {
                ...image,
                url: R2_CDN_BASE_URL + `${hotelId}/rooms/${room?.id}/${fileName}`,
              }
            }),
          }
        }),
      }
    }),
  }
}

// SE O LOCATOR É DA R2, ENTÃO RETORNA A URL DA R2 PARA OS WIDGETS, CASO CONTRÁRIO, RETORNA A URL DO CDN PADRÃO DA OMNIBEES
export const convertWidgetsToR2 = (locator: string, widgets: Widgets): Widgets => {
  if (!R2_LOCATORS.includes(locator)) {
    return widgets
  }
  return widgets?.map((widget) => ({
    ...widget,
    content: widget.content?.map((item) => {
      if (!item?.hotelId) return item
      const hotelId = item?.hotelId
      const fileName = item?.image?.split('/')?.[item?.image?.split('/')?.length - 1]
      return {
        ...item,
        image:
          item?.image && item?.image?.startsWith('https://media.omnibees.com')
            ? R2_CDN_BASE_URL + `${hotelId}/images/${fileName}`
            : item?.image,
        images: item?.images?.map((image) => {
          const fileName = image?.split('/')?.[image?.split('/')?.length - 1]
          if (image && image?.startsWith('https://media.omnibees.com')) {
            return R2_CDN_BASE_URL + `${hotelId}/images/${fileName}`
          }
          return image
        }),
      }
    }),
  }))
}
